import styled from "styled-components";

// Mesmo formato da caixa "Sobre a transcrição".
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin-bottom: 32px;
  padding: 12px 14px;
  background: var(--principal-10);
  border-left: 3px solid var(--principal-50);
  border-radius: 0 8px 8px 0;

  > p {
    font-size: 15px;
    line-height: 22px;
    color: var(--cinza-90);
    margin: 0;

    b {
      color: var(--cinza-100);
    }
  }
`;
